import styled from '@emotion/styled';
import Icon from '@components/common/Icon';

type Props = {
  isChecked: boolean;
  size?: string;
  className?: string;
  onClick?: () => void;
  opacity?: string;
  disabled?: boolean;
};

const CheckBoxIcon = ({
  isChecked,
  size = '14px',
  className = 'common-checkbox-container',
  onClick,
  opacity,
  disabled,
}: Props) => {
  return (
    <Container
      onClick={disabled ? undefined : onClick}
      className={className}
      isChecked={isChecked}
      opacity={opacity}
      disabled={disabled}
    >
      <ContainerInner isChecked={isChecked}>
        <Icon icon="IcCheckXSmall" size={size} color={'#fff'} />
      </ContainerInner>
    </Container>
  );
};

export default CheckBoxIcon;

const ContainerInner = styled.div<{ isChecked: boolean }>`
  display: flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
  padding: 1px;
  background: ${({ isChecked, theme }) => (isChecked ? theme.colors.shopl[300] : theme.colors.neutral[300])};
  border-radius: 4px;
`;

const Container = styled.div<{
  isChecked: boolean;
  opacity?: string;
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 8px;
  opacity: ${({ disabled }) => (disabled ? '0.3' : 'none')};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  ${ContainerInner} {
    &:hover {
      background: ${({ isChecked, theme, disabled }) =>
        !disabled ? (isChecked ? theme.colors.shopl[400] : theme.colors.neutral[400]) : ''};
    }
  }
`;
